import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AdminLoading from './AdminLoading';
import AdminEmptyState from './AdminEmptyState';
import { IoWarningOutline } from 'react-icons/io5';

export default function AdminRentalDamaged() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    api('/api/admin/rental/damaged')
      .then((data) => { setList(data); setError(''); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => load(), []);

  const handleRestore = async (productId) => {
    setError('');
    try {
      await api(`/api/admin/rental/damaged/${productId}/restore`, { method: 'POST' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <AdminLoading />;

  return (
    <Card>
      <CardHeader title="Damaged" subheader="Products hidden from website" />
      <CardContent>
        {error && <Typography color="error" className="admin-error" sx={{ mb: 2 }}>{error}</Typography>}
        {list.length === 0 ? (
          <AdminEmptyState message="No damaged products." icon={IoWarningOutline} />
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Code</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Inspection notes</TableCell>
                  <TableCell>Inspected at</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((r) => (
                  <TableRow key={r.id} hover>
                    <TableCell>{r.code}</TableCell>
                    <TableCell>{r.name}</TableCell>
                    <TableCell>{r.inspection_notes || '–'}</TableCell>
                    <TableCell>{r.inspected_at || '–'}</TableCell>
                    <TableCell align="right">
                      <Button size="small" variant="contained" color="success" onClick={() => handleRestore(r.id)}>
                        Restore
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}
